import { render, staticRenderFns } from "./ShopOwnerStaff.vue?vue&type=template&id=a5ef1cba&scoped=true&"
import script from "./ShopOwnerStaff.vue?vue&type=script&lang=ts&"
export * from "./ShopOwnerStaff.vue?vue&type=script&lang=ts&"
import style0 from "./ShopOwnerStaff.vue?vue&type=style&index=0&id=a5ef1cba&lang=scss&scoped=true&"
import style1 from "./ShopOwnerStaff.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ef1cba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
